import { render, staticRenderFns } from "./SafetyItems.vue?vue&type=template&id=da96f56a&"
import script from "./SafetyItems.vue?vue&type=script&lang=js&"
export * from "./SafetyItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports